module.exports = __webpack_public_path__ + "img/max-office-building-check.ee1f6414.svg";